import { useEffect, useState } from "react";
import { Download, Share, SquarePlus, X } from "lucide-react";
import { isIOS, isStandalone } from "@/lib/device";

const IOSSteps = () => (
  <ol data-testid="install-ios-steps" className="mt-1 space-y-1 text-sm text-slate-200">
    <li className="flex items-center gap-1.5">1. Open this page in <b className="text-white">Safari</b></li>
    <li className="flex items-center gap-1.5">2. Tap <Share className="w-4 h-4 text-sky-300" /> <b className="text-white">Share</b> at the bottom</li>
    <li className="flex items-center gap-1.5">3. Choose <SquarePlus className="w-4 h-4 text-sky-300" /> <b className="text-white">Add to Home Screen</b></li>
  </ol>
);

export const InstallPrompt = () => {
  const [evt, setEvt] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem("daybreak-install-dismissed") === "1");
  const ios = isIOS();

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  if (isStandalone() || hidden || (!evt && !ios)) return null;
  const dismiss = () => { localStorage.setItem("daybreak-install-dismissed", "1"); setHidden(true); };

  return (
    <div data-testid="install-prompt" className="mx-auto max-w-6xl px-4 sm:px-6 pt-4">
      <div className="flex items-start gap-3 rounded-2xl bg-navy-900 border border-navy-200 text-white p-4">
        <Download className="w-5 h-5 text-teal-300 shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-semibold">{ios ? "Put Daybreyk on your iPhone" : "Install Daybreyk as an app on this device."}</p>
          {ios && <><IOSSteps /><p className="mt-2 text-xs text-slate-300">Then open Daybreyk from your Home Screen to turn on notifications.</p></>}
        </div>
        {evt && <button data-testid="install-app-button" onClick={async () => { evt.prompt(); await evt.userChoice; setEvt(null); dismiss(); }} className="rounded-xl bg-brand px-4 py-2 text-sm font-semibold hover:bg-brand-dark">Install</button>}
        <button data-testid="install-dismiss" onClick={dismiss} aria-label="Dismiss" className="grid place-items-center w-8 h-8 rounded-lg text-slate-300 hover:bg-white/10"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
